import { InputSignal } from '@angular/core';
import { FilterItemConfig } from '../../../types/filter-config';
import { QueryFilter } from '@softline/core';
import { Filter } from '../../../types/filter';
import { FilterOperator } from '../../../types/filter-operators';
import { PageFilterDataService } from '../../services/data-source/page-filter-data.service';

export abstract class FilterInputBase<T extends object, TOperator extends FilterOperator> {
  readonly abstract item: InputSignal<FilterItemConfig<T>>;
  readonly abstract itemFilter: InputSignal<Filter<T> & { operator: TOperator } | null>;
  readonly abstract operator: InputSignal<TOperator>;
  readonly abstract dataService: InputSignal<PageFilterDataService<T>>;
  readonly abstract queryFilter: InputSignal<QueryFilter<T> | null>;

  abstract getFilterValue(): Filter<T> | null;
}
